// extracted by mini-css-extract-plugin
export default {"title":"EditTemplate_title__11vrV"};